var dayjs = require('dayjs');
dayjs.extend(require('dayjs/plugin/duration'));
dayjs.extend(require('dayjs/plugin/relativeTime'));
require('dayjs/locale/it');

import { now as fakeNow, streamDayKey } from './stream-day';

/**
 * "fra circa 3 ore" / "in meno di 2 ore" / "DOMANI".
 *
 * Input is a run start (`getRunStartDate()`: projected_start plus setup_time). The backend
 * has already folded every earlier overrun into it, so it is compared straight against
 * the real clock.
 *
 * Two rules that surprise people:
 *  - DOMANI follows the *stream day* (the Rome date of time - 6 h), so a 00:04 slot seen
 *    at 22:20 is still tonight and only a post-06:00 slot is tomorrow.
 *  - under an hour the two labels swap: below 30 minutes reads "in meno di un'ora", from
 *    30 minutes up reads "fra circa un'ora".
 */
export function getWaitTime(dateTo) {
    let now = dayjs(fakeNow());

    if (dateTo === undefined || dateTo === null) {
        return {
            label: '',
            duration: ''
        };
    }

    // "DOMANI" means the next *stream* day, not the next calendar day: the
    // marathon runs past midnight, so a 00:04 slot seen at 22:20 is still tonight.
    // Anything before 6 AM counts as the day before, same rule the schedule uses.
    if (streamDayKey(dateTo) > streamDayKey(now.valueOf())) {
        return {
            label: '',
            duration: 'DOMANI'
        };
    }

    let differenceInHoursRound = dayjs(dateTo).diff(now, "hours");
    let differenceInHours = dayjs(dateTo).diff(now, "hours", true);
    const minuteRemainder = differenceInHours % differenceInHoursRound || differenceInHours % 1;

    // >= 30M "IN MENO DI" H+1 || < 30M "FRA CIRCA"
    const moreThanHalfHour = minuteRemainder >= 0.5;
    let label = '';
    if (differenceInHoursRound > 0) label = moreThanHalfHour ? 'in meno di' : 'fra circa';
    else label = moreThanHalfHour ? 'fra circa' : 'in meno di';

    if (moreThanHalfHour) differenceInHoursRound += 1;

    // console.log(now, dateTo, differenceInHoursRound, differenceInHours, minuteRemainder);
    if (differenceInHoursRound < 1) differenceInHoursRound = 1;

    return {
        label: label,
        duration: dayjs.duration('PT' + differenceInHoursRound + 'H').locale('it').humanize().replace(/' /, "'")
    };
}

window.getWaitTime = getWaitTime;
